import React from "react";
import { SourceBaseViewType } from "../api-generated";
import SourceTypeIcon from "./SourceTypeIcon";
import SourceActions, { SourceActionsProps } from "./SourceActions";

interface Props extends SourceActionsProps {
  sourceType: SourceBaseViewType;
  sourceName: string;
}

const SourceHeader: React.FC<Props> = ({
  sourceType,
  sourceName,
  ...props
}) => {
  return (
    <div className="flex gap-2 pb-4">
      <div className="max-h-8">
        <SourceTypeIcon type={sourceType} />
      </div>
      <h2 className="text-md font-bold">{sourceName}</h2>
      <SourceActions {...props} />
    </div>
  );
};

export default SourceHeader;
